import Checkbox from "component/checkbox/checkbox"

interface ExtraBedPricingProps {
    seasonalExtraBedPricing: boolean
    onSeasonalExtraBedPricingChange: (value: boolean) => void
    error?: string
}

const ExtraBedPricing = ({ seasonalExtraBedPricing, onSeasonalExtraBedPricingChange, error }: ExtraBedPricingProps) => {
    return (
        <>
            <b>Is The Extra Bed Price The Different Across All Seasons?</b>
            <div className="checkbox-group">
                <Checkbox
                    label="Yes"
                    checked={seasonalExtraBedPricing}
                    onChange={() => onSeasonalExtraBedPricingChange(true)}
                />
                <Checkbox
                    label="No"
                    checked={!seasonalExtraBedPricing}
                    onChange={() => onSeasonalExtraBedPricingChange(false)}
                />
            </div>
            {error && (
                <div className="error-message" style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px" }}>
                    {error}
                </div>
            )}
        </>
    )
}

export default ExtraBedPricing
